import { render, staticRenderFns } from "./FactoryForm.vue?vue&type=template&id=8aa1bd26&scoped=true"
import script from "./FactoryForm.vue?vue&type=script&lang=js"
export * from "./FactoryForm.vue?vue&type=script&lang=js"
import style0 from "./FactoryForm.vue?vue&type=style&index=0&id=8aa1bd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa1bd26",
  null
  
)

export default component.exports